module.exports = __webpack_public_path__ + "static/media/export.4ee596a3.csv";